import { ArticleDefinition } from './Article';

export enum NotificationType {
  MESSAGE,
  MESSAGE_WITH_LIST,
  MESSAGE_WITH_SELECTION,
  MESSAGE_WITH_LINK,
  MULTIPLE_MESSAGES,
}

export type Notification =
  | MessageNotification
  | MessageWithListNotification
  | MessageWithProductSelection
  | MessageWithLinkNotification
  | MultipleMessagesNotification;

export enum NotificationTheme {
  DEFAULT = 'default',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning',
}

interface BaseNotification {
  id: string;
  title?: string;
  message: string;
  theme: NotificationTheme;
  timeout: number;
  placeholder?: string;
}

export interface MessageNotification extends BaseNotification {
  type: NotificationType.MESSAGE;
}

export interface MessageWithListNotification extends BaseNotification {
  type: NotificationType.MESSAGE_WITH_LIST;
  list: string[];
}

export interface MessageWithProductSelection extends BaseNotification {
  type: NotificationType.MESSAGE_WITH_SELECTION;
  articles: ArticleDefinition[];
}

export interface MessageWithLinkNotification extends BaseNotification {
  type: NotificationType.MESSAGE_WITH_LINK;
  url: string;
}

export interface MultipleMessagesNotification extends BaseNotification {
  type: NotificationType.MULTIPLE_MESSAGES;
  messages: string[];
}
